<template>
    <div class="dashboard-scheduled-services">
       <div class="row">
           <div class="col-12">
               <div class="card">
                   <div class="card-header d-flex justify-content-between align-items-center p-2 text-black">
                       <div class="d-flex align-items-center gap-3">
                            <div class="d-flex gap-1">
                                <PreviousDateIcon v-model="currentDate" />
                                <NextDateIcon v-model="currentDate" />
                                <CalendarIcon
                                    v-model="currentDate"
                                    :auto-apply="true"
                                    :size="23"
                                />
                            </div>
                            <div>
                                Scheduled services ({{ dataTimeFormat(currentDate, 'ddd, D MMM, YYYY')}})
                            </div>
                       </div>
                       <div class="d-flex gap-1">
                           <div class="d-flex align-items-center gap-1">
                               <input type="text" class="form-control form-control-sm" placeholder="Search..." v-model="filters.search">
                           </div>
                           <div class="d-flex align-items-center">
                               <Download
                                    :size="24"
                                    :stroke-width="2"
                                    :class="'text-theme cursor-pointer'"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    data-bs-title="Export to CSV"
                                    @click="downloadScheduledServices"
                                />
                           </div>
                       </div>
                   </div>
                   <div class="card-body overflow-auto p-2">
                    <table class="table hm-fs-12 align-middle table-hover table-sm">
                        <thead>
                            <tr>
                                <th scope="col" class="bg-theme">Customer</th>
                                <th scope="col" class="bg-theme">Property</th>
                                <th scope="col" class="bg-theme">Service</th>
                                <th scope="col" class="bg-theme text-end">Next Scheduled</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="processing">
                                <td colspan="4" class="text-center">
                                    <Loader />
                                </td>
                            </tr>
                            <tr v-else-if="scheduledServices.length" v-for="(service, index) in scheduledServices" :key="index">
                                <td>
                                    {{ service?.customer?.name || 'N/A' }}
                                </td>
                                <td>
                                    <span v-tooltip.top="service.address.full_address || ''">{{ preparePropertyAddress(service.address) }}</span>
                                </td>
                                <td>
                                    {{ service.service.name }}
                                </td>
                                <td class="text-end">
                                    {{ dataTimeFormat(service.next_due_date, 'DD MMM, YYYY') }}
                                </td>
                            </tr>
                             <tr v-else>
                                <td colspan="4" class="text-center">
                                    No scheduled services found.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                   </div>
               </div>
           </div>
       </div>
    </div>
</template>
<script>
import { appMixin } from '../../mixin/appMixin';
import {
    MapPinPlus,
    Download,
    MapPinOff
} from 'lucide-vue-next';

import NextDateIcon from '../partials/NextDateIcon.vue';
import PreviousDateIcon from '../partials/PreviousDateIcon.vue';
import CalendarIcon from '../partials/CalendarIcon.vue';
import Loader from '../partials/Loader.vue';

// Import the directive
import { tooltipDirective } from '../../directives/tooltip';

export default {
    name: 'DashboardScheduledServices',
    mixins: [appMixin],
    components: {
        MapPinPlus,
        Download,
        MapPinOff,
        NextDateIcon,
        PreviousDateIcon,
        CalendarIcon,
        Loader
    },
    directives: {
        tooltip: tooltipDirective
    },
    data() {
        return {
            processing: true,
            currentDate: new Date(),
            scheduledServices: [],
            filters: {
                search: '',
                searchType: 'this_month'
            }
        };
    },
    mounted() {
        this.getScheduledServices();
    },
    computed: {

    },
    watch: {
        'currentDate': function(newDate, oldDate) {
            this.getScheduledServices();
        },
        'filters.search': function(newSearch, oldSearch) {
            this.getScheduledServices();
        }
    },
    methods: {
        getScheduledServices() {
            this.processing = true;
            axios.post('/api/admin/scheduled-services/list', {
                next_scheduled_date: this.dataTimeFormat(this.currentDate, 'YYYY-MM-DD'),
                search_term: this.filters.search
            })
            .then(response => {
                this.scheduledServices = response.data.scheduled_services || [];
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                this.processing = false;
            });
        },
        preparePropertyAddress(property) {
            let addressParts = [
                property.address,
            ];

            // Check if address have only numbers then add address_1
            if (/^\d+$/.test(property.address)) {
                addressParts.push(property.address_line_1);
            }

            // Add postal code
            addressParts.push(property.postal_code);

            return addressParts.filter(part => part).join(', ');
        },
        downloadScheduledServices() {
            // Define CSV headers to match the table columns
            const headers = ['Customer', 'Property', 'Service', 'Next Scheduled'];
            
            // Create CSV content with headers
            let csv = headers.join(',') + '\r\n';

            // Add data rows
            this.scheduledServices.forEach(service => {
                const row = [
                    `"${service.customer?.name || 'N/A'}"`,
                    `"${service.address.full_address || 'N/A'}"`,
                    `"${service.service?.name || 'N/A'}"`,
                    `"${this.dataTimeFormat(service.next_due_date, 'DD MMM, YYYY')}"`
                ];
                csv += row.join(',') + '\r\n';
            });

            // Create and trigger download
            const blob = new Blob(["\uFEFF" + csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `scheduled_services_${this.dataTimeFormat(this.currentDate, 'YYYY-MM-DD')}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
    }
};
</script>
